export class ContactForm {
    public name: string = '';
    public email: string = '';
    public subject: string = '';
    public body: string = '';
    public verifyCode: string = '';

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/models/contact-form.ts